import { render, staticRenderFns } from "./LeaveFlip.vue?vue&type=template&id=e5f21cce&scoped=true&"
import script from "./LeaveFlip.vue?vue&type=script&lang=js&"
export * from "./LeaveFlip.vue?vue&type=script&lang=js&"
import style0 from "./LeaveFlip.vue?vue&type=style&index=0&id=e5f21cce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5f21cce",
  null
  
)

export default component.exports